var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('list-of-internment-today')],1),_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('list-of-internment-not-yet-schedule')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }